//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux'

//firebase
import { db } from 'assets/firebase';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-54225103-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class PurchaseList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      purchases: []
    };
  }

  componentWillMount() {

    if (this.props.user.authenticated) {

      db.getPurchases(this.props.org.id).then(snapshot => {
        var purchases = [];
        snapshot.forEach((doc) => {
          
          var x = doc.data();
          var created = new Date(x.created*1000);
          var total = "$" + x.amount / 100;

          for(var i = 0; i < this.props.products.length; i++) {
            if(this.props.products[i].id === x.productId) {
              x.product = this.props.products[i];
              break;
            }
          }

          var visitStart = new Date(x.validityStartDate*1000);
          var duration = (x.product.HoursValid * 60) * 60; // get seconds from hours
          var visitEnd = new Date((x.validityStartDate + duration)*1000);
          var visitDates = visitStart.toLocaleDateString() + " to " + visitEnd.toLocaleDateString();

          for(var j = 0; j < this.props.locations.length; j++) {
            if(this.props.locations[j].id === x.locationId) {
              x.location = this.props.locations[j];
              break;
            }
          }

          purchases.push([created.toLocaleDateString(), created.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}), x.location.Name, x.product.Name, total, visitDates]);
        });
        
        this.setState({purchases:purchases});
      });
      
    }
  }

render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("admin.haleakala.app/purchases");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <h4 className={classes.cardTitleWhite}>Purchases</h4>
              <p className={classes.cardCategoryWhite}>
                This table shows the history of successful product purchases.
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="primary"
                tableHead={["Date", "Time", "Location", "Product", "Amount", "Visit Date(s)"]}
                tableData={this.state.purchases}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

PurchaseList = connect(mapStateToProps)(PurchaseList);
export default withStyles(styles)(PurchaseList);